export default __webpack_public_path__ + "static/aid_character_glass-8bfc23c73fb750a984e8e63802dc8aff.svg";